import React from "react";
import Styles from "../../styles/sorting/SortingDescription.module.css";

type sortingType = {
  time: string;
  space: string;
  inplace: boolean;
  stable: boolean;
  class: string;
  method: string;
  code: string;
};

function SortingDescriptionComponent({ ...data }) {
  // console.log(data.code);
  const algos = [
    data.time,
    data.avg,
    data.best,
    data.space,
    data.inplace ? "True" : "False",
    data.stable ? "True" : "False",
  ];
  return (
    <div className={Styles.container}>
      <h1 className={Styles.heading}>{data.name}</h1>
      <p className={Styles.description}>{data.description}</p>
      <div className={Styles.divider} />
      <div className={Styles.dataContainer}>
        {algos.map((item, index) => (
          <div
            className={Styles.left}
            key={index}
            style={{
              borderLeftWidth: index % 2 === 0 ? 3 : 0,
              borderRightWidth: index % 2 === 0 ? 0 : 3,
              borderLeftColor: index % 2 === 0 ? "#880088" : "#22222d",
              borderRightColor: index % 2 === 0 ? "#22222d" : "#880088",
              justifyContent: index % 2 === 0 ? "flex-start" : "flex-end",
            }}
          >
            <p className={Styles.value}>
              {index === 0 && "Worst Complexity : " + item}
              {index === 1 && "Average Complexity : " + item}
              {index === 2 && "Best Complexity : " + item}
              {index === 3 && "Space Complexity : " + item}
              {index === 4 && "Inplace : " + item}
              {index === 5 && "Stable : " + item}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SortingDescriptionComponent;
